// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';  // Optional, for global styles
import App from './App'; // Import the main App component

ReactDOM.render(
  <React.StrictMode>
    <App />  {/* This is where we render the App component */}
  </React.StrictMode>,
  document.getElementById('root') // Make sure there's an element with id 'root' in your public/index.html
);
